import { AgColumnDefinition, AgGridColumnType, AgGridExportType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { store } from '@/store/store'

export const billingConfigInvoiceConceptsGridColumnDefs =
    (): Array<AgColumnDefinition> => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('accounting.field.concept'),
            children: [
                {
                    headerName: i18n.tc('accounting.field.deliveryNote'),
                    field: 'deliveryNote.label',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    minWidth: 150,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('accounting.field.verificationDate'),
                    field: 'deliveryNote.verificationDate',
                    type: AgGridColumnType.DATETIME,
                    exportType: AgGridExportType.DATETIME,
                    minWidth: 80,
                    flex: 1,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('accounting.field.reference'),
                    field: 'referenceCode',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    minWidth: 150,
                    flex: 1,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('accounting.field.concept'),
                    field: 'concept.name',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    minWidth: 200,
                    flex: 1,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('accounting.field.value'),
                    field: 'invoiceProportionalValue',
                    type: AgGridColumnType.DECIMAL,
                    exportType: AgGridExportType.DOUBLE,
                    minWidth: 100,
                    flex: 1,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('accounting.field.rate'),
                    field: 'rate.name',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    minWidth: 150,
                    flex: 1,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('accounting.field.caseNumber'),
                    field: 'caseStudy.caseNumber',
                    colId: 'caseStudy.casCasenumber',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    minWidth: 100,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('accounting.field.receptionDate'),
                    colId: 'caseStudy.casRequestDate',
                    field: 'caseStudy.receptionDate',
                    type: AgGridColumnType.DATETIME,
                    exportType: AgGridExportType.DATETIME,
                    minWidth: 150,
                    flex: 1,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('accounting.field.insuranceDocument'),
                    field: 'caseStudy.referralNumber',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    minWidth: 150,
                    flex: 1,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('accounting.field.insurancePolicy'),
                    field: 'caseStudy.insuranceNumber',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    minWidth: 150,
                    flex: 1,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('accounting.field.insurance'),
                    field: 'caseStudy.insurer.name',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    minWidth: 150,
                    flex: 1,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('accounting.field.isCopayment'),
                    field: 'isCopayment',
                    type: AgGridColumnType.CHECK_ICON,
                    exportType: AgGridExportType.BOOLEAN,
                    minWidth: 80,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('accounting.field.hasCopayment'),
                    field: 'hasCopayments',
                    type: AgGridColumnType.CHECK_ICON,
                    exportType: AgGridExportType.BOOLEAN,
                    minWidth: 80,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('accounting.field.copaymentType'),
                    field: 'copaymentType',
                    type: AgGridColumnType.BILLING_COPAYMENT_TYPE,
                    exportField: 'copaymentType.translatedName',
                    exportType: AgGridExportType.TEXT,
                    minWidth: 80,
                    suppressSizeToFit: true
                }
            ]
        },
        {
            headerName: i18n.tc('global.patient'),
            children: [
                {
                    headerName: i18n.tc('global.name'),
                    field: 'caseStudy.patient.name',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    minWidth: 100,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('global.surname1'),
                    field: 'caseStudy.patient.surname1',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    minWidth: 100,
                    suppressSizeToFit: true
                },
                {
                    headerName: i18n.tc('global.surname2'),
                    field: 'caseStudy.patient.surname2',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    minWidth: 100,
                    suppressSizeToFit: true
                },
                {
                    headerValueGetter: () => store.getters.parameters.global?.mainPatientIdentifierType.name,
                    colId: 'caseStudy.patient.mainPatientIdentifier',
                    field: 'caseStudy.patient.mainPatientIdentifier.paiIdentifier',
                    type: AgGridColumnType.TEXT,
                    exportType: AgGridExportType.TEXT,
                    minWidth: 100,
                    suppressSizeToFit: true
                }
            ]
        }
    ]
